import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import Modal from 'react-bootstrap-modal'
import DatePicker from 'react-datepicker'
import BirthdayInput from '../player-modal/inputs/date-input'
import PhoneInputWrapper from '../player-modal/inputs/phone-input-wrapper'
import TextInputWrapper from '../player-modal/inputs/text-input-wrapper'
import SelectInputWrapper from '../player-modal/inputs/select-input-wrapper'
import FlashAlert from '../flash-alert'
import { ajaxGet, patchForm, postForm } from '../../ajax'
import moment from 'moment'
import { formatPhoneNumberIntl } from 'react-phone-number-input'
import History from './history'
import track from '../../utils/mixpanel-event'

export default function ClientModal({playerId, contactsPage, onClose, onUpdate, onCreate}) {
  const [player, setPlayer] = useState(null)
  const { register, setValue, control, reset, handleSubmit } = useForm({})
  const [alert, setAlert] = useState(null)
  const [phone, setPhone] = useState()
  const [countryCode, setCountryCode] = useState()

  useEffect(() => {
    if (!playerId) return setPlayer({ phone: '', birthday: null })
    if (contactsPage) track('Open Client Info')

    loadPlayer()
  }, [])

  useEffect(() => {
    if (player) {
      reset(_.omit(player, 'id', 'image_url', 'display_name', 'joined_on', 
        'declined_payments_count', 'skill_level', 'captain', 'opted_out', 'credit', 'nationality'))
      setPhone(player.phone)
      setCountryCode(player.country_code)
    }
  }, [player])

  const loadPlayer = () => {
    ajaxGet(`/admins/players/${playerId}.json?client=true`)
    .then(response => { if (response.ok) return response.json() })
    .then((json) => { setPlayer(json.player) })
  }

  const processNewClient = () => {
    track('Add Client')
    onCreate({ order: 'ASC'})
  }

  const onSubmit = (data) => {
    let formData = new FormData()
    for (const key in data) { if (data[key]) formData.append(`player[${key}]`, data[key]) }
    formData.append('player[country_code]', countryCode)

    const formMethod = playerId ? patchForm : postForm
    formMethod(playerId ? `/admins/players/${playerId}.json` : `/admins/facility_clients`, formData)
    .then(response => { return response.json() })
    .then((json) => {
      if (json.alert)
        setAlert(json.alert)
      else {
        playerId ? onUpdate(json.player) : processNewClient()
      }
    })
  }

  if (!player) return null

  const genderOptions = [['male', 'Male'], ['female', 'Female']]

  return <Modal container={document.body} show={true} onHide={onClose} dialogClassName='modal-xs' className='player-profile'>
    <Modal.Header closeButton>
      <Modal.Title>{ playerId ? 'Client Information' : 'Add a new client' }</Modal.Title>
    </Modal.Header>
    { playerId &&
      <ul className='nav nav-tabs'>
        <li role='presentation' className='active'>
          <a data-toggle='tab' href='#player-info'>Profile</a>
        </li>
        <li role='presentation'>
          <a data-toggle='tab' href='#player-history'>History</a>
        </li>
      </ul>
    }
    <div className='tab-content'>
      <div id='player-info' className='tab-pane fade in active'>
        <Modal.Body>
          { alert && <FlashAlert text={alert.text} type={alert.type} onHide={() => setAlert(null)} />}
          <form className='edit_player' onSubmit={handleSubmit(onSubmit)}>
            <TextInputWrapper
              {...register('first_name')}
              label='First Name'
              labelColSize='3'
              inputColSize='9'
              onChange={(e) => {
                setValue('first_name', e.target.value)
              }} />
            <TextInputWrapper
              {...register('last_name')}
              label='Last Name'
              labelColSize='3'
              inputColSize='9'
              onChange={(e) => {
                setValue('last_name', e.target.value)
              }} />
            <PhoneInputWrapper
              {...register('phone')}
              labelColSize='3'
              inputColSize='9'
              defaultValue={formatPhoneNumberIntl(player.phone)}
              phone={phone}
              onChange={(p, c) => {
                setValue('phone', p)
                setPhone(p)
                setCountryCode(c.toUpperCase())
              }} />
            <div className='form-group row'>
              <label className='control-label col-lg-3' htmlFor='birthday'>Date of Birth</label>
              <div className='col-lg-9'>
                <Controller
                  control={control}
                  name='birthday'
                  render={({ field }) => (
                    <DatePicker
                      customInput={<BirthdayInput />}
                      onChange={(date) => field.onChange(date.format('MM/DD/YYYY'))}
                      selected={moment(new Date(field.value))}
                    />
                  )}
                />
              </div>
            </div>
            <TextInputWrapper
              {...register('email')}
              label='Email'
              labelColSize='3'
              inputColSize='9'
              onChange={(e) => {
                setValue('email', e.target.value)
              }} />
            <TextInputWrapper
              {...register('nickname')}
              label='Nickname'
              labelColSize='3'
              inputColSize='9'
              onChange={(e) => {
                setValue('nickname', e.target.value)
              }} />
            <SelectInputWrapper
              {...register('gender')}
              label='Gender'
              options={genderOptions}
              labelColSize='3'
              inputColSize='9'
              onChange={(e) => {
                setValue('gender', e.target.value)
              }} />
            <TextInputWrapper
              {...register('instagram')}
              label='Instagram'
              labelColSize='3'
              inputColSize='9'
              onChange={(e) => {
                setValue('instagram', e.target.value)
              }} />
            <div className='form-group row'>
              <label className='control-label col-lg-3' htmlFor='info'>Notes</label>
              <div className='col-lg-9'>
                <textarea
                  {...register('info')}
                  rows='5'
                  className='form-control'
                  onChange={(e) => {
                    setValue('info', e.target.value)
                  }} />
              </div>
            </div>
            <div className='form-group row'>
              <div className='col-lg-offset-3 col-lg-9'>
                <input type='submit' value='Save' className='btn btn-primary' />
              </div>
            </div>
          </form>
        </Modal.Body>
      </div>
      { playerId &&
        <div id='player-history' className='tab-pane fade'>
          <Modal.Body>
             <History events={player.events}/>
          </Modal.Body>
        </div>
      }
    </div>
  </Modal>
}
